const menuRouteList = [
  {
    id: 100, parentId: 0, title: "首页", name: "NaviHome", path: "", redirect: 'index', component: "LayoutSite", hidden: false, openType: 0,
    meta: {menuType: 'C', icon: "", cache: false, link: false},
  },
  {
    id: 100101, parentId: 100, name: "ViewHome", path: "index", component: "home/index.vue",
    meta: {menuType: 'V', icon: "", cache: false},
  },
  // {
  //   id: 100102 , parentId: 100, name: "ViewUserProfile", path: "user/profile", component: "sys/profile/index.vue",
  //   meta: {menuType: 'V', icon: "", cache: false},
  // },


  // {
  //   id: 101200, parentId: 0, name: "NaviDev", path: "/dev", hidden: false, component: "Layout",
  //   meta: {menuType: 'M', title: "开发管理", icon: "", cache: false, link: false}
  // },
  // {
  //   id: 102000, parentId: 0, name: "NaviData", path: "/data", hidden: false, component: "Layout",
  //   meta: {menuType: 'M', title: "数据开发", icon: "", cache: false, link: false}
  // },
  // {
  //   id: 103100, parentId: 0, name: "NaviSolution",  path: "/solution", hidden: false, component: "Layout",
  //   meta: {menuType: 'M', title: "产品方案", icon: "", cache: false, link: false}
  // },
  // {
  //   id: 109000, parentId: 0, name: "NaviSys",  path: "/sys", hidden: false, component: "Layout",
  //   meta: {menuType: 'M', title: "系统管理", icon: "", cache: false, link: false}
  // },

  // {
  //   id: 101210, parentId: 101200, path: "wiki", redirect: 'wiki/index', hidden: false,
  //   meta: {menuType: 'C', title: "知识库", icon: "menu-doc", cache: false, link: false}
  // },
  // {
  //   id: 101211, parentId: 101210, name: "ViewDocWiki", path: "index", component: "wiki/index.vue",
  //   meta: {menuType: 'V', icon: "", cache: false},
  // },
  // {
  //   id: 101220, parentId: 101200, path: "mgmt", hidden: false,
  //   meta: {menuType: 'M', title: "开发管理", icon: "menu-app", cache: false, link: false}
  // },
  // {
  //   id: 101221, parentId: 101220, name: "MenuApiDoc", path: "apiDoc", redirect: `${process.env["VUE_APP_SERVER_HOST"]}/doc.html`, hidden: false,
  //   meta: {menuType: 'C', title: "接口文档", cache: false, link: true, linkType: 'blank'},
  // },
  // {
  //   id: 101230, parentId: 101200, path: "component", redirect: 'component/index', hidden: false,
  //   meta: {menuType: 'C', title: "组件管理", icon: "menu-doc", cache: false, link: false}
  // },
  //
  //
  // {
  //   id: 102100, parentId: 102000, path: "ai", hidden: false,
  //   meta: {menuType: 'M', title: "数据AI", icon: "menu-edit", cache: false, link: false}
  // },
  // {
  //   id: 102200, parentId: 102000, path: "visual", hidden: false,
  //   meta: {menuType: 'M', title: "数据可视化", icon: "menu-edit", cache: false, link: false}
  // },
  // {
  //   id: 102300, parentId: 102000, path: "model", hidden: false,
  //   meta: {menuType: 'M', title: "模型管理", icon: "menu-edit", cache: false, link: false}
  // },
  // {
  //   id: 102400, parentId: 102000, path: "gemini", hidden: false,
  //   meta: {menuType: 'M', title: "数据API", icon: "menu-edit", cache: false, link: false}
  // },
  // {
  //   id: 102500, parentId: 102000, path: "taurus", hidden: false,
  //   meta: {menuType: 'M', title: "动态指标", icon: "menu-edit", cache: false, link: false}
  // },
  //
  // // 数据源管理
  // {
  //   id: 102600, parentId: 102000, name: "MenuSqlQuerySupport", path: "sqlQuery", redirect: 'sqlQuery/index', hidden: false,
  //   meta: {menuType: 'C', title: "自助查询", icon: "menu-edit", cache: false, link: false,},
  // },
  // {
  //   id: 102610, parentId: 102600, name: "ViewSqlQuerySupport", path: "index", hidden: false, component: "gemini/sqlQuery/index.vue",
  //   meta: {menuType: 'V', title: "查询列表", icon: "", cache: false},
  // },
  //
  // {
  //   id: 101311, parentId: 102100, name: "MenuChatForm", path: "chatform", redirect: 'chatform/index', hidden: false,
  //   meta: {menuType: 'C', title: "ChatForm", cache: false, link: false},
  // },
  // {
  //   id: 101312, parentId: 101311, name: "ViewChatForm", path: "index", hidden: false, component: "dataAi/chatform/index.vue",
  //   meta: {menuType: 'V', title: "ChatForm", icon: "", cache: false},
  // },
  // {
  //   id: 101313, parentId: 102100, name: "MenuChatBI", path: "chatbi", redirect: 'chatbi/index', hidden: false,
  //   meta: {menuType: 'C', title: "ChatBI", cache: false, link: false},
  // },
  // {
  //   id: 101314, parentId: 101313, name: "ViewChatBI", path: "index", hidden: false, component: "dataAi/chatbi/index.vue",
  //   meta: {menuType: 'V', title: "ChatBI", icon: "", cache: false},
  // },
  //
  //
  // {
  //   id: 101331, parentId: 102200, name: "MenuScreenList", path: "screen", redirect: 'screen/list', hidden: false,
  //   meta: {menuType: 'C', title: "数据大屏", cache: false, link: false},
  // },
  // {
  //   id: 101333, parentId: 101331, name: "ViewScreenList", path: "list", hidden: false, component: "datavisual/screen/list.vue",
  //   meta: {menuType: 'V', title: "大屏列表", icon: "", cache: false},
  // },
  // {
  //   // component是和父级Layout同级的不一样，所以不能相对于父级route，path就必须加/
  //   id: 101335, parentId: 102200, name: "MenuScreenDesign", path: "/screen", redirect: 'screen/design', component: "LayoutFull", hidden: true,
  //   meta: {menuType: 'C', title: "大屏设计", cache: false, link: false, linkType: 'blank'},
  // },
  // {
  //   id: 101337, parentId: 101335, name: "ViewScreenDesign", path: "design", hidden: false, component: "datavisual/screen/design.vue",
  //   meta: {menuType: 'V', title: "设计列表", icon: "", cache: false},
  // },
  // {
  //   // component是和父级Layout同级的不一样，所以不能相对于父级route，path就必须加/
  //   id: 101338, parentId: 102200, name: "MenuScreenPreview", path: "/screen", redirect: 'screen/preview', component: "LayoutFull", hidden: true,
  //   meta: {menuType: 'C', title: "大屏预览", cache: false, link: false, linkType: 'blank'},
  // },
  // {
  //   id: 101339, parentId: 101338, name: "ViewScreenPreview", path: "preview", hidden: false, component: "datavisual/screen/preview.vue",
  //   meta: {menuType: 'V', icon: "预览列表", cache: false},
  // },
  //
  // {
  //   id: 101340, parentId: 102200, name: "MenuFormList", path: "form", redirect: 'form/list', hidden: false,
  //   meta: {menuType: 'C', title: "表单管理", cache: false, link: false,},
  // },
  // {
  //   id: 101342, parentId: 101340, name: "ViewFormList", path: "list", hidden: false, component: "datavisual/form/list.vue",
  //   meta: {menuType: 'V', title: "表单列表", icon: "", cache: false},
  // },
  // {
  //   // component是和父级Layout同级的不一样，所以不能相对于父级route，path就必须加/
  //   id: 101344, parentId: 102200, name: "MenuFormDesign", path: "/form", redirect: 'form/design', component: "LayoutFull", hidden: true,
  //   meta: {menuType: 'C', title: "表单设计", cache: false, link: false, linkType: 'blank'},
  // },
  // {
  //   id: 101346, parentId: 101344, name: "ViewFormDesign", path: "design", hidden: false, component: "datavisual/form/design.vue",
  //   meta: {menuType: 'V', icon: "表单列表", cache: false},
  // },
  // {
  //   // component是和父级Layout同级的不一样，所以不能相对于父级route，path就必须加/
  //   id: 101348, parentId: 102200, name: "MenuFormPreview", path: "/form", redirect: 'form/preview', component: "LayoutFull", hidden: true,
  //   meta: {menuType: 'C', title: "表单预览", cache: false, link: false, linkType: 'blank'},
  // },
  // {
  //   id: 101349, parentId: 101348, name: "ViewFormPreview", path: "preview", hidden: false, component: "datavisual/form/preview.vue",
  //   meta: {menuType: 'V', icon: "表单列表", cache: false},
  // },
  //
  // {
  //   id: 101350, parentId: 102200, name: "MenuReport", path: "report", redirect: `${process.env["VUE_APP_SERVER_HOST"]}/jmreport/list`, hidden: false,
  //   meta: {menuType: 'C', title: "积木报表", cache: false, link: true, linkType: 'blank', authentication: true, key: 'authorization'},
  // },
  //
  //
  // {
  //   id: 101354, parentId: 102200, name: "MenuDesignDashboard", path: "dashboard", redirect: 'dashboard/index', hidden: true,
  //   meta: {menuType: 'C', title: "仪表盘设计", cache: false, link: false,},
  // },
  // {
  //   id: 101356, parentId: 101354, name: "ViewDesignDashboard", path: "index", hidden: false, component: "datavisual/dashboard/index.vue",
  //   meta: {menuType: 'V', title: "仪表盘列表", icon: "", cache: false},
  // },
  //
  // {
  //   id: 101358, parentId: 102200, name: "MenuDataFlowList", path: "dataflow", redirect: 'dataflow/list', hidden: false,
  //   meta: {menuType: 'C', title: "数据流任务", cache: false, link: false},
  // },
  // {
  //   id: 101359, parentId: 101358, name: "ViewDataFlowList", path: "list", hidden: false, component: "dataflow/list.vue",
  //   meta: {menuType: 'V', title: "流任务列表", icon: "", cache: false},
  // },
  //
  // // 模型管理
  // {
  //   id: 101371, parentId: 102300, name: "MenuModelList", path: "model", redirect: 'model/list', hidden: false,
  //   meta: {menuType: 'C', title: "模型管理", cache: false, link: false,},
  // },
  // {
  //   id: 101372, parentId: 101371, name: "ViewModelList", path: "list", hidden: false, component: "gemini/model/list.vue",
  //   meta: {menuType: 'V', icon: "模型列表", cache: false},
  // },
  //
  // // 数据源管理
  // {
  //   id: 101381, parentId: 102400, name: "MenuApiDesignList", path: "apiDesign", redirect: 'apiDesign/list', hidden: false,
  //   meta: {menuType: 'C', title: "API设计", cache: false, link: false,},
  // },
  // {
  //   id: 101382, parentId: 101381, name: "ViewApiDesignList", path: "list", hidden: false, component: "gemini/apidesign/list.vue",
  //   meta: {menuType: 'V', icon: "设计列表", cache: false},
  // },
  // {
  //   id: 101383, parentId: 101381, name: "ViewApiDesignEdit", path: "edit", hidden: false, component: "gemini/apidesign/edit.vue",
  //   meta: {menuType: 'V', title: "接口编辑", icon: "", cache: false},
  // },
  // {
  //   id: 101384, parentId: 101381, name: "ViewApiDesignConfig", path: "config", hidden: false, component: "gemini/apidesign/config.vue",
  //   meta: {menuType: 'V', title: "接口配置", icon: "", cache: false},
  // },
  // {
  //   id: 101385, parentId: 101381, name: "ViewApiDesignDetail", path: "detail", hidden: false, component: "gemini/apidesign/detail.vue",
  //   meta: {menuType: 'V', title: "接口详情", icon: "", cache: false},
  // },
  // {
  //   id: 101386, parentId: 102400, name: "MenuApiApproveList", path: "apiApprove", redirect: 'apiApprove/list', hidden: false,
  //   meta: {menuType: 'C', title: "API审批", cache: false, link: false,},
  // },
  // {
  //   id: 101387, parentId: 101386, name: "ViewApiApproveList", path: "list", hidden: false, component: "gemini/apiapprove/list.vue",
  //   meta: {menuType: 'V', icon: "审批列表", cache: false},
  // },
  // {
  //   id: 101387, parentId: 101386, name: "ViewApiApproveEdit", path: "edit", hidden: false, component: "gemini/apiapprove/edit.vue",
  //   meta: {menuType: 'V', icon: "审批详情", cache: false},
  // },
  //
  // {
  //   id: 102500, parentId: 102400, name: "MenuDatasourceList", path: "datasource", redirect: 'datasource/list', hidden: false,
  //   meta: {menuType: 'C', title: "数据源配置", cache: false, link: false,},
  // },
  // {
  //   id: 101391, parentId: 102500, name: "ViewDatasourceList", path: "list", hidden: false, component: "gemini/datasource/list.vue",
  //   meta: {menuType: 'V', icon: "配置列表", cache: false},
  // },
  //
  // // 解决方案-信托
  //
  // {
  //   id: 1031001, parentId: 103100, path: "trust", hidden: false,
  //   meta: {menuType: 'M', title: "信托管理", icon: "", cache: false, link: false}
  // },
  // {
  //   id: 10310011, parentId: 1031001, name: "", path: "trust", redirect: 'introduction/index', hidden: false,
  //   meta: {menuType: 'C', title: "产品介绍", cache: false, link: false},
  // },
  // {
  //   id: 103100111, parentId: 10310011, name: "ViewTrust", path: "index", hidden: false, component: "solution/introduction.vue",
  //   meta: {menuType: 'V', icon: "", cache: false},
  // },
  //
  //
  // // 系统管理
  // {
  //   id: 101930, parentId: 109000, path: "mgmt", hidden: false,
  //   meta: {menuType: 'M', title: "监控管理", icon: "", cache: false, link: false}
  // },
  // {
  //   id: 101931, parentId: 101930, name: "MenuMonitor", path: "group", redirect: 'monitor/list', hidden: false,
  //   meta: {menuType: 'C', title: "Log监控", cache: false, link: false},
  // },
  // {
  //   id: 101932, parentId: 101931, name: "ViewMonitor", path: "list", hidden: false, component: "sys/monitor/list.vue",
  //   meta: {menuType: 'V', icon: "", cache: false},
  // },
  // {
  //   id: 101910, parentId: 109000, path: "permission", hidden: false,
  //   meta: {menuType: 'M', title: "权限管理", icon: "", cache: false, link: false}
  // },
  // {
  //   id: 101911, parentId: 101910, name: "MenuTenant", path: "tenant", redirect: 'tenant/list', hidden: false,
  //   meta: {menuType: 'C', title: "租户管理", cache: false, link: false},
  // },
  // {
  //   id: 1019111, parentId: 101911, name: "ViewTenant", path: "list", hidden: false, component: "sys/tenant/index.vue",
  //   meta: {menuType: 'V', icon: "", cache: false},
  // },
  // {
  //   id: 101913, parentId: 101910, name: "MenuUser", path: "user", redirect: 'user/list', hidden: false,
  //   meta: {menuType: 'C', title: "用户管理", cache: false, link: false},
  // },
  // {
  //   id: 1019131, parentId: 101913, name: "ViewUser", path: "list", hidden: false, component: "sys/user/index.vue",
  //   meta: {menuType: 'V', icon: "", cache: false},
  // },
  // {
  //   id: 101915, parentId: 101910, name: "MenuRole", path: "role", redirect: 'role/list', hidden: false,
  //   meta: {menuType: 'C', title: "角色管理", cache: false, link: false},
  // },
  // {
  //   id: 1019151, parentId: 101915, name: "ViewRole", path: "list", hidden: false, component: "sys/role/index.vue",
  //   meta: {menuType: 'V', icon: "", cache: false},
  // },
  // {
  //   id: 101920, parentId: '1870849749407588354', path: "resource", hidden: false,
  //   meta: {menuType: 'M', title: "资源管理", icon: "", cache: false, link: false}
  // },
  // {
  //   id: 101921, parentId: 101920, name: "MenuResource", path: "menu", redirect: 'menu/list', hidden: false,
  //   meta: {menuType: 'C', title: "菜单管理", cache: false, link: false},
  // },
  // {
  //   id: 1019211, parentId: 101921, name: "ViewSysMenuList", path: "list", hidden: false, component: "sys/menu/index.vue",
  //   meta: {menuType: 'V', icon: "", cache: false},
  // },


]
export default menuRouteList;
